import { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { AppLayout } from "../../components/layout/Header";
import RestoreTimeline from "../../components/restore/RestoreTimeline";
import { useAuth } from "../../js/hooks/useAuth";

export default function RestoreDesk() {
  const { session } = useAuth();
  const [flash, setFlash] = useState("");
  if (!session?.userId) return <Navigate to="/" replace />;

  const variant =
    session.role === "admin"
      ? "admin"
      : session.role === "broker"
        ? "broker"
        : session.role === "agent"
          ? "agent"
          : session.role === "seller"
            ? "seller"
            : "buyer";

  return (
    <AppLayout variant={variant}>
      <div className="account-portal">
        <header className="page-header">
          <div>
            <h1>Restore points</h1>
            <p className="page-lead">
              Your work is saved continuously on this device. If something goes wrong, pick a snapshot and restore.
            </p>
            <p className="muted">
              For a full copy to keep long-term, <Link to="/backup">export a backup</Link>.
            </p>
          </div>
        </header>
        {flash ? <p className="confirm-banner">{flash}</p> : null}
        <RestoreTimeline session={session} userId={session.userId} onFlash={setFlash} />
      </div>
    </AppLayout>
  );
}
